module.exports = __webpack_public_path__ + "img/wolt4.1be9157b.jpg";